__turbopack_context__.v({
  "container": "CaseStudyList-module__D4IE3a__container",
});
